import React from 'react';
import { Box, ButtonBase } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import EventIcon from '@mui/icons-material/Event';

import { TOKENS, BRAND } from '../theme';

// Segmented "By Employee | By Day" switch at the top of the Employee
// Sessions root screen. Sticky like the Raffle mode tabs (.rf-tabs): it comes
// to rest under the app's top bar (0) and contextual toolbar (75px), whose
// height is MUI's Toolbar min-height — 56px below 600px, 64px from there —
// hence 131/139. z-index stays under the toolbar's 20.
export const ROOT_VIEWS = { EMPLOYEE: 'employee', DAY: 'day' };

const OPTIONS = [
  { value: ROOT_VIEWS.EMPLOYEE, label: 'By employee', Icon: PersonIcon },
  { value: ROOT_VIEWS.DAY, label: 'By day', Icon: EventIcon },
];

export default function RootViewTabs({ value, onChange }) {
  return (
    <Box
      sx={{
        position: 'sticky',
        top: { xs: 131, sm: 139 },
        zIndex: 10,
        px: 2,
        py: 1.5,
        background: '#fff',
        borderBottom: `1px solid ${TOKENS.slate200}`,
      }}
    >
      {/* Same segmented control as Points Watching's By session / By
          employee toggle */}
      <Box
        role="tablist"
        sx={{
          display: 'flex',
          maxWidth: 520,
          p: 0.5,
          borderRadius: 3,
          background: BRAND.track,
        }}
      >
        {OPTIONS.map(({ value: v, label, Icon }) => {
          const active = value === v;
          return (
            <ButtonBase
              key={v}
              role="tab"
              aria-selected={active}
              onClick={() => onChange(v)}
              sx={{
                flex: 1,
                gap: 1,
                py: 1.25,
                borderRadius: 2,
                fontSize: 14,
                fontWeight: 600,
                color: active ? '#fff' : BRAND.ink,
                background: active ? BRAND.navy : 'transparent',
                transition: 'background 150ms, color 150ms',
              }}
            >
              <Icon sx={{ fontSize: 18 }} /> {label}
            </ButtonBase>
          );
        })}
      </Box>
    </Box>
  );
}
